<div class="calendar-container">
    <div class="calendar-header">
        <button mat-icon-button (click)="navigate(-1)"
            matTooltip="Previous Month"><mat-icon>arrow_back_ios</mat-icon></button>
        <div class="calendar-header-buttons">
        <button mat-button (click)="goToToday()" matTooltip="Go to this month">Today</button>
        <button mat-button [matMenuTriggerFor]="monthYearMenu" matTooltip="Select month and year">
            {{ currentMonth | date: 'MMMM yyyy' }}
            <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #monthYearMenu="matMenu">
            <div style="padding: 20px;" (mousedown)="$event.stopPropagation()">
                <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()">
                    <mat-label>Month</mat-label>
                    <mat-select [(ngModel)]="selectedMonth" required (click)="$event.stopPropagation()">
                        <mat-option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()">
                    <mat-label>Year</mat-label>
                    <input matInput type="number" [(ngModel)]="selectedYear" required
                        (click)="$event.stopPropagation()">
                </mat-form-field>

                <button mat-button (click)="onMonthYearChange()">Set</button>
            </div>
        </mat-menu>
        </div>
        <button mat-icon-button (click)="navigate(1)"
            matTooltip="Next Month"><mat-icon>arrow_forward_ios</mat-icon></button>
    </div>
    <div class="calendar-grid">
        <div class="day-name" *ngFor="let dayName of dayNames">{{ dayName }}</div>
        <ng-container *ngFor="let day of days; let dayIndex = index">
            <div class="month-cell"
                [ngClass]="{'today': day.isToday, 'outside': !day.inMonth, 'unavailable': day.inMonth && !day.isAvailable, 'selected': selectedDay && day.date && selectedDay.getTime() === day.date.getTime()}"
                (click)="selectDay(day)">
                <div class="cell-top">
                    <span class="cell-day"><span class="cell-number">{{ day.number }}</span><span class="today-label" *ngIf="day.isToday">Today</span></span>
                    <div class="appointment-counters" *ngIf="day.taskCounts.length">
                        <div *ngFor="let count of day.taskCounts" class="appointment-count-circle" [matTooltip]="count.type"
                            [ngStyle]="{'background-color': count.backgroundColor,'color': count.textColor, 'border': count.borderColor ? '2px solid ' + count.borderColor : '' }">
                            {{ count.count }}
                        </div>
                    </div>
                </div>

                <div class="bars" *ngIf="day.bars.length">
                    <ng-container *ngFor="let bar of day.bars">
                        <div *ngIf="bar; else freeLane" class="bar" [class.holiday]="bar.event.holiday"
                            [class.continues-before]="bar.continuesBefore" [class.continues-after]="bar.continuesAfter"
                            [matTooltip]="bar.event.title">
                            <span class="bar-title" *ngIf="bar.label" [style.--span]="bar.span">{{ bar.event.title }}</span>
                        </div>
                        <ng-template #freeLane><div class="bar free"></div></ng-template>
                    </ng-container>
                </div>

                <div class="lines" *ngIf="day.preview as preview">
                    <div class="line" *ngFor="let line of preview.lines" [class.inactive]="line.inactive"
                        [matTooltip]="line.title">
                        <span class="line-dot" [style.background-color]="line.color"></span>
                        <span class="line-title">{{ line.title }}</span>
                    </div>
                    <div class="more" *ngIf="preview.more">+{{ preview.more }} more</div>
                </div>
            </div>
        </ng-container>

        <!-- Conditionally render the expanded row -->
        <div *ngIf="selectedDay && tasksForSelectedDay && startOfWeekIndex !== null" class="appointments-for-day"
            [style.gridRowStart]="getTaskRowStart()" [style.gridColumn]="getTaskColumnSpan()"
            [@rowAnimation]="'active'">
            <div class="row-header">
                <h3>Tasks for {{ selectedDay | date: 'fullDate' }}:</h3>
                <!-- <div class="actions">
                    <button mat-icon-button color="primary" (click)="openScheduleDialog()"
                        *ngIf="isFutureDate(selectedDay)" matTooltip="Add Task">
                        <mat-icon>add_task</mat-icon>
                    </button>
                </div> -->
            </div>
            <ng-container *ngIf="tasksForSelectedDay && tasksForSelectedDay.length; else noResults">
                <div class="compact-day task-day">
                    <div class="compact-row clickable" *ngFor="let task of tasksForSelectedDay" (click)="loadTask(task)"
                        [class.inactive]="task.status === 'Cancelled'"
                        [appPatientValidationStatus]="task.Patient ?? {}" #valStatus="appPatientValidationStatus"
                        [appPatientActive]="task.Patient?.id">
                        <span class="type-bar" [matTooltip]="task.status"
                            [ngStyle]="{'background-color': task.typeDetails?.backgroundColor}"></span>
                        <span class="who">
                            <span class="name">{{ task.Patient?.surname }}, {{ task.Patient?.name }}</span>
                            <span class="number" *ngIf="task.Patient?.patientNumber">({{ task.Patient.patientNumber }})</span>
                        </span>
                        <span class="flags">
                            <app-patient-validation-messages [valStatus]="valStatus" [iconsOnly]="true"></app-patient-validation-messages>
                        </span>
                        <span class="what" [matTooltip]="task.task">{{ task.task }}</span>
                        <span class="assignees" [matTooltip]="'Assigned to: ' + assigneeSummary(task)">{{ assigneeSummary(task) }}</span>
                        <span class="state" [ngClass]="task.status === 'Pending' ? 'arrived' : (task.status || '').toLowerCase()">{{ task.status }}</span>
                        <div class="actions">
                            <button mat-icon-button color="primary" *ngIf="task.status !== 'Completed'"
                                (click)="updateTaskStatus($event, task, 'Completed')"
                                matTooltip="Mark task as completed">
                                <mat-icon>check_circle</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" *ngIf="task.status !== 'Pending'"
                                (click)="updateTaskStatus($event, task, 'Pending')"
                                matTooltip="Mark task as pending">
                                <mat-icon>pending_actions</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" *ngIf="task.status !== 'Cancelled'"
                                (click)="updateTaskStatus($event, task, 'Cancelled')"
                                matTooltip="Mark task as cancelled">
                                <mat-icon>cancel</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" matTooltip="View Patient"
                                (click)="navigateToPatientFile($event, task.Patient.id)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="mobile-spacer"></div>

</div>

<ng-template #noResults>
    <p class="no-records-message">No tasks found.</p>
</ng-template>